export default __webpack_public_path__ + "static/tools-ce019ecde3a13e81fe7a4fd61bb83180.png";